export function addSpinner ( targetEl, dark ) {
  targetEl.classList.add('loading');
  let spinnerEl = document.createElement('div');
  spinnerEl.classList.add('lds-ring');
  if( dark ){
    spinnerEl.classList.add('dark');
  }
  for( var x = 0; x < 3; x++ ){
    let childDiv = document.createElement('div');
    spinnerEl.appendChild(childDiv);
  }
  targetEl.appendChild( spinnerEl );
}

export function removeSpinner ( targetEl ) {
  console.log('removing spinner');
  targetEl.removeChild( targetEl.firstChild );
  targetEl.classList.remove('loading');
}

export function setSpinnerText( targetEl, text ){

}
